<template>
  <span class="tartag"
        :class="'tartag_'+type">
    <slot></slot>{{label}}
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      switch (this.type) {
        case 'NotLabeled':
          return '未标注'
        case 'Pending':
          return '等待审核'
        case 'Passed':
          return '审核通过'
        case 'Rejected':
          return '审核驳回'
        case 'Reviewed':
          return '审核完成'
        default:
          return '未知类型'
      }
    },
  },
}
</script>

<style lang="scss">
.tartag {
  border-radius: 5px;
  font-size: 0.8em;
  padding: 2px 4px;
  margin-right: 5px;
  &_NotLabeled {
    // background: rgba(144, 147, 153, 0.25);
    background: rgba(230, 162, 60, 0.25);
  }
  &_Pending {
    background: rgba(230, 162, 60, 0.25);
  }
  &_Passed {
    background: rgba(103, 194, 58, 0.25);
  }
  &_Rejected {
    background: rgba(245, 108, 108, 0.25);
  }
  &_Reviewed {
    background: rgba(103, 194, 58, 0.25);
  }
}
</style>
